<template>
  <div id="close-panel" class="m-background--media-1">
    <div v-if="!formSubmitted">
      <div class="nav-close" @click="close()">
        <div class="m-btn__cross"></div>
      </div>
      <h4>Can you help us?</h4>
      <p>
        We'd really appreciate your answer to the following question &ndash;
        please rate whether you agree with the following statement
      </p>
      <div class="question-panel">
        <p>{{ questionText }}</p>
        <form v-on:submit.prevent="submit">
          <p class="errors" v-if="errors.length">
            <strong>Please correct the following error(s):</strong>
            <span v-for="error in errors" :key="error">{{ error }}. </span>
          </p>
          <div class="keys">
            <span class="disagree">Disagree</span>
            <span class="somewhat">Somewhat Agree</span>
            <span class="agree">Agree</span>
          </div>
          <div class="responses">
            <div v-for="n in 10" :key="n" class="response">
              <input
                type="radio"
                name="followUpScore"
                :value="n"
                :checked="selectedOption === n"
                v-on:input="selectedOption = $event.target.checked ? n : 0"
              />
              <label :for="n">{{ n }}</label>
            </div>
          </div>
          <p>
            <button type="submit" class="m-btn__primary__floating">
              Submit
            </button>
          </p>
          <button
            v-if="enableSkip"
            @click="skip()"
            class="m-btn__primary__floating"
          >
            Skip, I just want to restart the game
          </button>
        </form>
      </div>
    </div>
    <div v-if="formSubmitted">
      <h4>Thank you</h4>
      <button @click="close">Close</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { UserTypes } from '../contants'

export default {
  props: {
    enableSkip: Boolean
  },
  data () {
    return {
      errors: [],
      selectedOption: 0,
      formSubmitted: false
    }
  },
  computed: {
    ...mapGetters(['getUserType']),

    questionText () {
      const userType = this.getUserType
      switch (userType) {
        case UserTypes.PARENT:
          return 'I feel that I now have better understanding of some of the challenges my son or daughter may come across whilst living in shared accommodation and have a better idea of how I can help them better prepare for this.'
        case UserTypes.TEACHER:
          return 'Leapskills will help young people prepare better for living in shared accommodation and the transition to independent living?'
        case UserTypes.STUDENT:
          return 'I feel that I now have better understanding of some of the challenges I may come across whilst living in shared accommodation and have idea of how I may overcome them.'
      }

      // this should never happen, but this seems like the best fallback
      return 'person'
    }
  },
  methods: {
    ...mapActions(['setFollowUpQuestionAsked', 'updateFeedback']),
    submit () {
      this.errors = []

      if (!this.selectedOption) {
        this.errors.push('Please select an answer')
      }

      if (this.errors.length) {
        return
      }

      this.saveFollowUpResponse()
      this.setFollowUpQuestionAsked()
      this.formSubmitted = true
    },
    saveFollowUpResponse () {
      this.updateFeedback({
        key: 'betterUnderstanding',
        val: this.selectedOption
      })
    },
    skip () {
      this.close()
    },
    close () {
      this.setFollowUpQuestionAsked()
      this.$emit('close')
    }
  },
  name: 'FollowUpQuestion'
}
</script>

<style scoped lang="scss">
form {
  margin: 0;
}
#close-panel {
  width: 98%;
  height: 580px;
  top: 10px;
  left: 1%;
  position: absolute;
  z-index: 5000;
  padding: 50px;
  color: #333;
  display: block;
  box-shadow: 0px 0px 5px 2px #333;
}
.question-panel {
  background: #fff;
  border-radius: 10px;
  padding: 30px;
}
.question-panel p {
  font-size: 150%;
  font-weight: bold;
}
.nav-close {
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
}

h4 {
  padding: 0;
  margin: 0 0 10px 0;
}
p {
  padding: 0;
  margin: 0 0 10px 0;
  width: 100%;
  white-space: normal;
}

.keys {
  display: flex;
  justify-content: space-between;
  margin: 0 0 20px 0;
}

.responses {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 0 0 30px 0;
  text-align: center;
}
.responses input[type='radio'] {
  display: block;
  -webkit-appearance: none;
  appearance: none;
  background-color: #fff;
  margin: 0;
  font: inherit;
  color: currentColor;
  width: 2em;
  height: 2em;
  border: 0.1em solid #ce492c;
  border-radius: 50%;
  display: grid;
  place-content: center;
}

.responses input[type='radio']::before {
  content: '';
  width: 1em;
  height: 1em;
  border-radius: 50%;
  transform: scale(0);
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em #ce492c;
}

.responses input[type='radio']:checked::before {
  transform: scale(1);
}

.responses label {
  display: block;
  font-size: 90%;
  color: #999;
  transform: translateX(0.75em);
  margin: 10px 0 0 0;
}

.m-btn__primary__floating {
  border: none;
  font-size: 70%;
}

.followup_option {
  display: block;
}

@media (max-width: 899px) {
  #close-panel {
    padding: 30px 25px;
    h4 {
      padding: 0;
      margin: 0 0 10px 0;
    }
    p {
      padding: 0;
      margin: 0 0 10px 0;
      width: 100%;
      font-size: 70%;
      white-space: normal;
    }
    .question-panel {
      padding: 15px;
    }
    .keys {
      margin: 0 0 5px 0;
      font-size: 80%;
    }
    .responses {
      margin: 0 0 10px 0;
    }
    .responses input[type='radio'] {
      width: 1.4em;
      height: 1.4em;
    }
    .responses input[type='radio']::before {
      width: 0.7em;
      height: 0.7em;
    }
    .question-panel p {
      font-size: 90%;
      font-weight: bold;
      margin: 0 0 10px 0;
    }
    .m-btn__primary__floating {
      font-size: 90%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FollowUpQuestion.vue